
import Vue from "vue";
import {DossierConfigService} from "@/services";
import {IBreadCrumb} from "winfakt-vue-components";
import AppTranslationInput from "@/components/TranslationInput.vue";


export default Vue.extend({
	data(){
		return {
			config: DossierConfigService.getTaxesConfig(),
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("components.sale-settings.sale/purchase")
				},
				{
					value: this.$ct("taxes")
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		async save(){
			this.config = await DossierConfigService.saveTaxesConfig(this.config);
			this.$wf.notify(this.$ct("saved"), "success", 3000, "check");
		},
	},
	components: {
		AppTranslationInput
	},
	i18nEx: {
		componentPrefix: "components.settings-taxes"
	}
});
